import styled from 'styled-components';
import Box from '../layout/Box';
var UnorderedList = styled(Box).attrs({
  as: 'ul'
}).withConfig({
  displayName: "UnorderedList",
  componentId: "sc-5q065b-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme,
      $variant = _ref.$variant;
  return $variant && theme.expandVariants($variant, theme.typography.lists.unordered);
});
UnorderedList.displayName = 'UnorderedList';
export default UnorderedList;